import { Link } from "react-router-dom";
import LogoutButton from "../LogoutButton/LogoutButton";
import useAuthorizationData from "../../../utils/useAuthorizationData";
import "./HeaderContent.css";
import { Col, Row } from "antd";

const HeaderContent = () => {
  const [authorizationData] = useAuthorizationData();

  return (
    <>
      <div className="header-container">
        <Row>
          <Col span={24}>
            <Row>
              <Col xs={24} sm={24} md={4} lg={4} xl={4} xxl={4}>
                <Link className="header-logo" to="/"></Link>
              </Col>
              <Col xs={24} sm={24} md={20} lg={20} xl={20} xxl={20}>
                  {authorizationData == null ? (
                    <div className="header-links">
                      <Link to="/login" className="header-link">
                        Login/Register
                      </Link>
                    </div>
                  ) : (
                    <div className="header-links">
                      <Link to="/addvisit" className="header-link">
                        Add Visit
                      </Link>
                      <Link to="/visit" className="header-link">
                        My Visit
                      </Link>
                      <LogoutButton></LogoutButton>
                    </div>
                  )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

HeaderContent.displayName = "HeaderContent";

export default HeaderContent;
